import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { servicePackage } from './servicePackage';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { service } from './service';
import { serviceProvider } from './serviceProvider';
import {groupForServiceReservationAddNew} from "./groupForServiceReservationAddNew";
import {activityReservationForServiceReservationAddNew} from "./activityReservationForServiceReservationAddNew";

export const serviceReservationAddNew: SchemaWithClient<any> = {
  name: 'Service Reservations View',
  pluralName: 'Service Reservations',
  columns: {
    group: {
      name: 'Group',
      fieldRenderer: SelectField.tableAdapter(groupForServiceReservationAddNew),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(groupForServiceReservationAddNew),
      url: groupForServiceReservationAddNew.client.getAllPath,
      tempSchema: groupForServiceReservationAddNew,
      switchboard: true,
    },
    activity_reservation: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activityReservationForServiceReservationAddNew()),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(activityReservationForServiceReservationAddNew()),
      url: activityReservationForServiceReservationAddNew().client.getAllPath,
      tempSchema: activityReservationForServiceReservationAddNew(),
      switchboard: true,
      accordingTo: 'group',
    },
    service_package: {
      name: 'Service Group',
      fieldRenderer: SelectField.tableAdapter(servicePackage()),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(servicePackage()),
      url: servicePackage().client.getAllPath,
      tempSchema: servicePackage(),
      switchboard: true,
      accordingTo: 'activity_reservation',
    },

    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(serviceProvider),
      switchboard: true,
      url: serviceProvider.client.getAllPath,
      tempSchema: serviceProvider,
      accordingTo: 'activity_reservation',
    },
    service: {
      name: 'Service',
      fieldRenderer: SelectField.tableAdapter(service),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(service),
      url: service.client.getAllPath,
      tempSchema: service,
      switchboard: true,
      accordingTo: 'service_provider',
    },
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },

  client: new Client(`/service-reservations/create`),
};
